import { Controller } from "@hotwired/stimulus"

// Drives the canvas-size control on the deck metadata form (ADR-0077).
// A preset <select> (Slidepack / Dashboard / Custom) sets the two real
// number fields (canvas_w / canvas_h) that actually post. The custom
// wrapper is hidden unless "custom" is chosen — the fields stay in the DOM
// (never disabled) so their values still submit while hidden.
export default class extends Controller {
  static targets = ["select", "custom", "width", "height"]

  static presets = {
    "1280x720": { w: 1280, h: 720 },
    "1920x1080": { w: 1920, h: 1080 }
  }

  connect() {
    const key = `${this.widthTarget.value}x${this.heightTarget.value}`
    if (this.constructor.presets[key]) {
      this.selectTarget.value = key
      this.customTarget.classList.add("hidden")
    } else {
      this.selectTarget.value = "custom"
      this.customTarget.classList.remove("hidden")
    }
  }

  change() {
    const value = this.selectTarget.value
    const preset = this.constructor.presets[value]

    if (preset) {
      this.widthTarget.value = preset.w
      this.heightTarget.value = preset.h
      this.customTarget.classList.add("hidden")
    } else {
      this.customTarget.classList.remove("hidden")
    }
  }
}
